import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Divider,
  Grid,
  Group,
  LoadingOverlay,
  Menu,
  Modal,
  Pagination,
  Paper,
  Tabs,
  Text,
  Tooltip
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { Buffer } from 'buffer';
import React, { useEffect, useState } from "react";
import {
  FaFileExport,
  FaFileImport,
  FaPencilAlt,
  FaTrash
} from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import CSVListManager from "../components/CSVListManager";
import InputField, { InputFieldTypes } from "../components/input_field";
import NewContact from "../components/new_contact";
import SimpleHeader from "../components/simple_header";
import Table from "../components/table";
import { useApp } from "../contexts/app.context";
import { useAuth } from "../contexts/auth.context";
import { useLanguage } from "../contexts/language.context";
import {
  DELETE_CONTACT_FROM_LIST,
  DELETE_CONTACT_LIST,
  GET_CONTACT_LIST,
  GET_CONTACT_LIST_CONTACTS,
  SAVE_CONTACT_LIST
} from "../services/contacts";
import { GET_ALL_TAGS } from "../services/tags";
import { parseKeyword } from "../utility/util";
import { GET_FIELDS } from "../services/companies";

export default function Home() {
  const { id: listId } = useParams();
  const { user: currentUser, userData } = useAuth();
  const { role } = useAuth();

  const navigate = useNavigate();

  const { confirmDialog } = useApp();
  const { str } = useLanguage();
  const isMobile = useMediaQuery('(max-width: 900px)');

  const utf8 = require("utf8");

  const [contacts, setContacts] = useState<any[]>([]);
  const [data, setData] = useState<any>(null);
  const [filters, setFilters] = useState<any>({
    search: "",
    tags: [],
  });
  const [selectedTab, setSelectedTab] = useState<string | null>("all");
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingContacts, setLoadingContacts] = useState<boolean>(false);
  const [loadingImport, setLoadingImport] = useState<boolean>(false);
  const [validFile, setValidFile] = useState<boolean>(false);
  const [shownContacts, setShownContacts] = useState<any[]>([]);
  const [fields, setFields] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [quantity, setQuantity] = useState(20);
  const [uploadingFile, setUploadingFile] = useState<any>(null);
  const [newContact, setNewContact] = useState<any>(null);
  const [tags, setTags] = useState<any[]>([]);
  const [tagsCategories, setTagsCategories] = useState<any[]>([]);

  const loadTags = () => {
    GET_ALL_TAGS()
      .then(({ tags = [], categories = [] }) => {
        setTags(tags);
        setTagsCategories(categories);
      })
      .catch((err) => { });
  };
  const loadFields = () => {
    GET_FIELDS()
      .then((f) => {
        setFields(f)
      })
      .catch(err => {
        notifications.show({ title: "Ops.", message: err.message, color: 'red' })
      })
  };

  const loadData = (setLoading = true) => {
    if (listId && listId !== "unsigned") {
      setLoadingData(setLoading);
      GET_CONTACT_LIST(listId)
        .then((dt) => {
          setLoadingData(false);
          setData(dt);
        })
        .catch((err) => {
          setLoadingData(false);
          notifications.show({ title: "Ops", message: err.message, color: "red", });
        });
    }
  };

  const loadContacts = () => {
    if (listId) {
      setLoadingContacts(true)
      GET_CONTACT_LIST_CONTACTS(listId)
        .then((items) => {
          setLoadingContacts(false)
          setContacts(items.sort((a, b) => a.name > b.name ? 1 : -1));
        })
        .catch((err) => {
          setLoadingContacts(false)
        });
    }
  };

  const filterTags = (c: any) => {
    const keys: string[] = parseKeyword(filters.search)?.split(" ");
    return (
      [
        ...(c.name ? c.name.split(" ") : []),
        ...(c.identifiers || []).map((item: any) => item.value || " ")
      ].some(k => (
        keys.every(k2 => parseKeyword(k).includes(k2)))
      ) && (
        (filters.tags ?? []).every((t: any) => c.tags.map((ct: any) => ct.id).includes(t))
      )
    )
  }

  useEffect(() => {
    setShownContacts(contacts.filter(filterTags).filter(c => (
      (
        selectedTab === "all" ||
        (selectedTab === "unsubscribe" && (c.unsubscribe ?? [].length > 0)) ||
        (selectedTab === "contacted" && !!c.contacted) ||
        (selectedTab === "not_contacted" && !c.contacted)
      )
    )))
  }, [contacts, filters, selectedTab])

  // const deleteContact = (id) => {
  //   setLoadingDeleteContacts((d) => ({ ...d, [id]: true }));

  //   DELETE_CONTACT(id)
  //     .then(() => {
  //       setLoadingDeleteContacts((d) => ({ ...d, [id]: false }));
  //       navigate("/contatos");
  //       showNotification({
  //         title: "Sucesso",
  //         message: "Contato deletado com sucesso",
  //         color: "green",
  //       });
  //     })
  //     .catch((err) => {
  //       setLoadingDeleteContacts((d) => ({ ...d, [id]: false }));
  //       alert(err.message);
  //     });
  // };

  // const handleSaveContact = () => {
  //   if (listId) {
  //     setLoadingSave(true);
  //     const { props } = variables;
  //     const params = {
  //       extras,
  //       lists: selectedLists,
  //       identifiers,
  //       name: contactName,
  //     };

  //     UPDATE_CONTACT(params, listId)
  //       .then((dt) => {
  //         setLoadingSave(false);
  //         showNotification({
  //           title: "Sucesso",
  //           message: "Contato atualizado com sucesso",
  //           color: "green",
  //         });
  //       })
  //       .catch((err) => {
  //         setLoadingSave(false);
  //         showNotification({
  //           title: "Ops",
  //           message: err.message,
  //           color: "red",
  //         });
  //       });
  //   }
  // };

  const deleteContactList = () => {
    DELETE_CONTACT_LIST(listId)
      .then(() => {
        navigate("/lists");
      })
      .catch(err => {
        notifications.show({ message: err.message, color: "red" });
      })
  }

  const removeContact = (contactId) => {
    DELETE_CONTACT_FROM_LIST(contactId, listId)
      .then(() => {
        setContacts(c => c.filter(item => item.id !== contactId));
      })
      .catch(err => {
        notifications.show({ message: err.message, color: "red" });
      })
  }

  const importCsv = ({ items }: { items: Record<string, string>[] }) => {
    if (items.length > 0 && listId) {
      setLoadingImport(true);
      const CHUNK_SIZE = 1000;
      const chunks: any[] = [];

      for (let i = 0; i < items.length; i += CHUNK_SIZE) {
        chunks.push(items.slice(i, i + CHUNK_SIZE));
      }

      const uploadChunks = async () => {
        try {
          for (const chunk of chunks) {
            await SAVE_CONTACT_LIST({
              _id: listId,
              items: chunk,
            });
          }
          setLoadingImport(false);
          loadContacts();
          setUploadingFile(null);
        } catch (err: any) {
          setLoadingImport(false);
          notifications.show({ message: err.message, color: "red" });
        }
      };

      uploadChunks();
    }
  }
  const handleExportCsv = () => {
    const items = [
      ["Name", "Phone", "Email", ...fields.map(f => f.title)]
    ]

    for (let c of shownContacts) {
      items.push([
        c.name, c.phone, c.email, ...fields.map(f => c.extras[f.title] ?? ""),
      ])
    }

    const csvData = items.map(it => it.map(k => `"${k ?? ""}"`).join(",")).join("\n")
    // setLoadingExport(true)
    // EXPORT_CALLS({ ...filters, page })
    // .then(res => {
    // setLoadingExport(false)
    // for(let file of res.files ?? []){
    // if(file.url) window.open(file.url, "_blank");
    // if(file.base64){
    const byteCharacters = Buffer.from(csvData, "utf-8");
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters[i];
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: "application/csv" });

    const url = URL.createObjectURL(blob);;
    const a = document.createElement('a');
    a.href = url;
    a.download = `contacts.csv`;
    a.click();
    URL.revokeObjectURL(url);
    // }
    // }
    // })
    // .catch(err => {
    // setLoadingExport(false)
    // notifications.show({ message: err.message, color: "red" })
    // })
  }

  const handleDropFile = (files) => {
    console.log(files);
    const file = files[0];
    setUploadingFile(l => ({ ...l, file }));
    if (file) {
      const reader = new FileReader()
      reader.onload = async (e) => {
        try {
          const text = (e.target.result) as string;
          const lines = text.split("\n");
          const columns = lines[0].split(",").map(k => k.toLocaleLowerCase().replace("\r", ""));
          console.log(columns);
          setValidFile(columns.includes("phone") && columns.includes("name"))
        } catch (err) {
          setValidFile(false)
          notifications.show({ message: err.message, color: 'red' });
        }
      };
      reader.readAsText(file)
    } else {
      setValidFile(false)
    }
  }

  useEffect(() => {
    loadData();
    loadContacts();
    loadTags();
    loadFields();
  }, [listId]);

  const transformIdentifierData = (identifiers: any) => {
    let newIdentifiers = Object.assign([], identifiers);
    if (identifiers.length === 2 && identifiers[0].key === "phone") {
      return newIdentifiers;
    } else {
      if (newIdentifiers.length === 0) {
        newIdentifiers.push({ key: "phone", value: "" });
        newIdentifiers.push({ key: "email", value: "" });
      } else if (newIdentifiers[0].key === "email") {
        newIdentifiers.unshift({ key: "phone", value: "" });
      } else if (newIdentifiers[0].key === "phone") {
        newIdentifiers.push({ key: "email", value: "" });
      }
    }
    return newIdentifiers;
  };

  return <Box p="lg">
    <Paper mb="md" p="md">
      <Group align="flex-end" style={{ flexDirection: isMobile ? 'column' : 'row' }}>
        <Menu>
          <Menu.Target>
            <Button leftSection={<FaFileImport />}>{str("CONTACTS.ADD_CONTACTS")}</Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={() => setNewContact({})}>{str("CONTACTS.ADD_CONTACT")}</Menu.Item>
            <Menu.Item onClick={() => setUploadingFile({})}>{str("IMPORT_CSV")}</Menu.Item>
          </Menu.Dropdown>
        </Menu>
        <Grid style={{ flex: 1 }} justify="flex-end">
          {[
            tags.some(t => !t.category) && { _id: undefined, title: str("OTHERS") },
            ...tagsCategories,
          ].filter(nn => nn).map(tc => {
            const selfTags = (tags ?? []).filter(t => t.category === tc.id)
            return <Grid.Col key={`${tc.id}`} span={{ base: 12, md: 4 }}>
              <InputField
                name="tags"
                value={filters?.tags.filter(t => selfTags.some(t2 => t2.id === t))}
                onChange={({ tags }) => {
                  setFilters(f => {
                    let tgs = [...tags, ...f.tags.filter(t => !selfTags.map(t2 => t2.id).includes(t))]
                    return { ...f, tags: tgs }
                  })
                }}
                fieldType={InputFieldTypes.SELECT}
                title={tc.title}
                multiple
                options={selfTags
                  .map(t => ({
                    value: t.id,
                    label: `${t.title} (${contacts.filter(c => (c.tags ?? []).map(t2 => t2.id).includes(t.id)).length})`
                  }))}
              />
            </Grid.Col>
          })}
        </Grid>
      </Group>
    </Paper>
    <SimpleHeader
      title={
        <Group gap={20}>
          <Text fw="bold" size="xl">{data?.title ?? str("CONTACTS.UNSIGNEDS")}</Text>
          <Divider size="sm" color="white" orientation="vertical" />
          <Link to="/lists"><Text c="white" size="sm">{str("CONTACTS.BACK_TO_LISTS")}</Text></Link>
        </Group>
      }
      right={
        <Group>
          {/* <Button
            onClick={()}
          >
            Custom Fields
          </Button> */}
          <ActionIcon
            onClick={() => {
              confirmDialog({ text: str("CONTACTS.LISTS_DELETE_CONFIRM") }, ({ confirmed }) => {
                if (confirmed) {
                  deleteContactList()
                }
              })
            }}
          >
            <FaTrash />
          </ActionIcon>
        </Group>
      }
    />
    <Group align="flex-end">
      <Tabs
        value={selectedTab ?? "all"}
        onChange={setSelectedTab}
        variant="outline"
        style={{ flex: 1 }}
        styles={{ tab: { borderWidth: 4 } }}
      >
        <Tabs.List>
          <Tabs.Tab miw={200} value="all">{str("ALL")} <Badge>{contacts.filter(filterTags).length}</Badge></Tabs.Tab>
          <Tabs.Tab miw={200} value="contacted">{str("CONTACTS.CONTACTED")} <Badge>{contacts.filter(filterTags).filter(c => !!c.contacted).length}</Badge></Tabs.Tab>
          <Tabs.Tab miw={200} value="not_contacted">{str("CONTACTS.NOT_CONTACTED")} <Badge>{contacts.filter(filterTags).filter(c => !c.contacted).length}</Badge></Tabs.Tab>
          <Tabs.Tab miw={200} value="unsubscribe">{str("CONTACTS.UNSUBSCRIBED")} <Badge>{contacts.filter(filterTags).filter(c => (c.unsubscribe ?? [].length > 0)).length}</Badge></Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Tooltip label="Export data">
        <Button size="sm" variant="outline" onClick={() => {
          handleExportCsv()
        }} rightSection={<FaFileExport />}>{str("EXPORT")}</Button>
      </Tooltip>
    </Group>
    <Table
      sort={{ key: "name" }}
      columns={[
        { title: str("NAME"), key: 'name', style: { textAlign: 'left' } },
        { title: str("EMAIL"), key: 'email', style: { textAlign: 'left' } },
        { title: str("PHONE"), key: 'phone', style: { textAlign: 'left' } },
        {
          title: str("EDIT"), key: 'edit', itemStyle: { textAlign: 'center' }, render: (item) => (
            <ActionIcon
              color="gray"
              variant="outline"
              onClick={() => { navigate(`/contacts/${item.id}`) }}
            ><FaPencilAlt /></ActionIcon>
          )
        },
        listId !== "unsigned" && {
          title: str("DELETE"), key: 'delete', itemStyle: { textAlign: 'center' }, render: (item) => (
            <ActionIcon
              color="gray"
              variant="outline"
              onClick={() => {
                confirmDialog({ text: str("CONTACTS.REMOVE_CONTACT_FROM_LIST") }, ({ confirmed }) => {
                  if (confirmed) {
                    removeContact(item.id)
                  }
                })
              }}
            ><FaTrash /></ActionIcon>
          )
        },
      ].filter(nn => nn)}
      data={shownContacts.slice((page - 1) * quantity, (page) * quantity)}
    />

    <Group justify='flex-end'>
      <Pagination m="lg" total={(shownContacts.length / quantity) + 1} value={page} onChange={setPage} />
    </Group>

    <NewContact
      lists={(listId && listId !== "unsigned") ? [listId] : []}
      onSave={(c) => { loadContacts() }}
      open={Boolean(newContact)}
      data={newContact}
      onChange={(dt) => setNewContact(nt => ({ ...nt, ...dt }))}
      onClose={() => setNewContact(null)}
    />

    <Modal opened={!!uploadingFile} onClose={() => setUploadingFile(null)} size="xl">
      <CSVListManager
        attributes={[
          { key: "name", title: str("NAME") },
          { key: "phone", title: str("PHONE") },
          { key: "email", title: str("EMAIL") },
          ...(fields ?? []).map((a: any) => ({ key: a.title, title: a.title })),
        ]}
        loading={loadingImport}
        onUpload={importCsv}
      />

      {/* {uploadingFile?.file && !validFile && <Text ta="right" mt="md" c="red" size="xs">{str("CONTACTS.IMPORT_CSV_ERROR")}</Text>}
      <Group mt="xl" justify='flex-end'>
        <Button loading={loadingImport} disabled={!validFile} onClick={importCsv}>{str("SAVE")}</Button>
      </Group> */}
    </Modal>

    <LoadingOverlay visible={loadingData || loadingContacts} />
  </Box>
}
